import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

export class SubvencaoSituacao extends Component {
  static propTypes = {
    situacoes: PropTypes.object.isRequired
  };

  renderSituacoes = data => {
    return (
      <tr ref="row" key={data.get('id')}>
        <td>{DateUtils.formatDateTimeShort(data.get('data'))}</td>
        <td>{data.get('descricao')}</td>
        <td>{data.get('mes')}</td>
        <td>{DateUtils.formatDateTimeShort(data.get('dataPrevisao'))}</td>
        <td>{DateUtils.formatDateTimeShort(data.get('dataApresentacao'))}</td>
        <td>{data.get('tipoSituacao')}</td>
        <td>{DateUtils.formatDateTimeShort(data.get('dataSituacao'))}</td>
        <td>{DateUtils.formatDateTimeShort(data.get('prazoAnalise'))}</td>
        <td>{data.get('analise')}</td>
      </tr>
    );
  };

  render() {
    const { situacoes } = this.props;

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader empty={situacoes.isEmpty()}>
            <tr>
              <th>Data</th>
              <th>Descrição</th>
              <th>Mês</th>
              <th>Data Previsão</th>
              <th>Data Apresentação</th>
              <th>Tipo Situação</th>
              <th>Data Situação</th>
              <th>Prazo Análise</th>
              <th>Análise</th>
            </tr>
          </TableHeader>
          <tbody>{situacoes.map(this.renderSituacoes)}</tbody>
        </table>
      </div>
    );
  }
}

export default SubvencaoSituacao;
